var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c(
                "b-card-actions",
                {
                  staticClass: "h-345",
                  attrs: {
                    "show-loading": _vm.saving,
                    "action-collapse": "",
                    title:
                      _vm.$t("Dados da Conciliação") +
                      " #" +
                      _vm.reconciliation.id,
                  },
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "3" } },
                        [
                          _c("FormulateInput", {
                            attrs: {
                              id: "reconciliation-payoutId",
                              value: _vm.reconciliation.payoutId,
                              type: "label",
                              label: _vm.$t("Pagamento Stripe ID"),
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "3" } },
                        [
                          _c("FormulateInput", {
                            attrs: {
                              id: "reconciliation-checking-account",
                              value: _vm.reconciliation.checkingAccount.name,
                              type: "label",
                              label: _vm.$t("Conta Corrente"),
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "2" } },
                        [
                          _c("FormulateInput", {
                            attrs: {
                              id: "reconciliation-movement-date",
                              value: _vm.reconciliation.movementDate,
                              type: "label",
                              filter: "date",
                              label: _vm.$t("Data do Pagamento"),
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "2" } },
                        [
                          _c("FormulateInput", {
                            attrs: {
                              id: "invoice-percent-commission-tax",
                              value:
                                (_vm.reconciliation.percentCommissionTax || 0) /
                                100,
                              type: "label",
                              filter: "percentage",
                              label: _vm.$t("Taxa Comissão"),
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "2" } },
                        [
                          _c("FormulateInput", {
                            attrs: {
                              id: "invoice-status",
                              value: _vm.$t(
                                "Reconciliation_" + _vm.reconciliation.status
                              ),
                              type: "label",
                              label: _vm.$t("Status"),
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "2" } },
                        [
                          _c("FormulateInput", {
                            attrs: {
                              id: "reconciliation-amount",
                              value: _vm._f("currency")(
                                _vm.stripeTotalTransactions
                              ),
                              type: "label",
                              label: _vm.$t("Valor Transações"),
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "2" } },
                        [
                          _c("FormulateInput", {
                            attrs: {
                              id: "reconciliation-refund",
                              value: _vm._f("currency")(_vm.stripeTotalRefund),
                              type: "label",
                              label: _vm.$t("Valor Reembolsos"),
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "2" } },
                        [
                          _c("FormulateInput", {
                            attrs: {
                              id: "reconciliation-adjustment",
                              value: _vm._f("currency")(
                                _vm.stripeTotalAdjustment
                              ),
                              type: "label",
                              label: _vm.$t("Valor Disputas/Ajustes"),
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "2" } },
                        [
                          _c("FormulateInput", {
                            attrs: {
                              id: "reconciliation-reservedFund",
                              value: _vm._f("currency")(
                                _vm.stripeTotalReservedFund
                              ),
                              type: "label",
                              label: _vm.$t("Valor Reserva de Fundos"),
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "2" } },
                        [
                          _c("FormulateInput", {
                            attrs: {
                              id: "reconciliation-transfer",
                              value: _vm._f("currency")(
                                _vm.stripeTotalTransfer
                              ),
                              type: "label",
                              label: _vm.$t("Valor Transferências"),
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { md: "2" } },
                        [
                          _c("FormulateInput", {
                            attrs: {
                              id: "reconciliation-amount",
                              value: _vm._f("currency")(
                                _vm.reconciliation.amount
                              ),
                              type: "label",
                              label: _vm.$t("Valor Total Recebido"),
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c(
                "b-tabs",
                { attrs: { fill: "" } },
                [
                  _c(
                    "b-tab",
                    { attrs: { title: _vm.$t("Transações") } },
                    [
                      _c("reconciliation-item-table", {
                        attrs: { saving: _vm.saving, fetching: _vm.fetching },
                        on: { "get-data": _vm.getData },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-tab",
                    { attrs: { title: _vm.$t("Reembolsos") } },
                    [
                      _c("reconciliation-refund-item-table", {
                        attrs: { fetching: _vm.fetchingRefund },
                        on: { "get-data": _vm.getRefund },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-tab",
                    { attrs: { title: _vm.$t("Disputas/Ajustes") } },
                    [
                      _c("reconciliation-adjustment-item-table", {
                        attrs: { fetching: _vm.fetchingAdjustment },
                        on: { "get-data": _vm.getAdjustment },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-tab",
                    { attrs: { title: _vm.$t("Reserva de Fundos") } },
                    [
                      _c("reconciliation-reservedFund-item-table", {
                        attrs: { fetching: _vm.fetchingReservedFund },
                        on: { "get-data": _vm.getReservedFund },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-tab",
                    { attrs: { title: _vm.$t("Transferências") } },
                    [
                      _c("reconciliation-transfer-item-table", {
                        attrs: { fetching: _vm.fetchingTransfer },
                        on: { "get-data": _vm.getTransfer },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }